import Grid2 from "@mui/material/Unstable_Grid2";
import { CustomAutocomplete } from "../../../../../components/custom/CustomAutocomplete";
import { Box, Typography } from "@mui/material";
import { LooksTwo } from "@mui/icons-material";
import { COLORS } from "../../../../../ui/Theme";
import { useDomesticMarketSpreadPriceCategoryContext } from "../../../../../context/domestic-market/SpreadPrice/DomesticMarketSpreadPriceCategoryContext";

const CommodityForm2 = () => {
  const {
    industries2,
    fields2,
    companies2,
    groups2,
    commodities2,
    inputCategoryValues2,
    setInputCategoryValues2,
  } = useDomesticMarketSpreadPriceCategoryContext();

  const { industry, field, company, group, commodity } = inputCategoryValues2;

  const clearForm = (field) => {
    switch (field) {
      case "industry":
        setInputCategoryValues2((prev) => ({
          ...prev,
          field: null,
          company: null,
          group: null,
          commodity: null,
        }));
      case "field":
        setInputCategoryValues2((prev) => ({
          ...prev,
          company: null,
          group: null,
          commodity: null,
        }));
      case "group":
        setInputCategoryValues2((prev) => ({
          ...prev,
          company: null,
          commodity: null,
        }));
        break;
      case "company":
        setInputCategoryValues2((prev) => ({
          ...prev,
          commodity: null,
        }));
        break;
      default:
        break;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 900,
          display: "flex",
          alignItems: "center",
          justifyContent: { xs: "center", md: "flex-start" },
          gap: 0.5,
        }}
      >
        کالا
        <LooksTwo sx={{ color: COLORS.BLUE }} />
      </Typography>

      <Grid2 container spacing={"10px"}>
        <Grid2 xs={12} lg={2.4}>
          <CustomAutocomplete
            options={industries2.data}
            value={industry}
            onChange={(e, newValue) => {
              setInputCategoryValues2((prev) => ({
                ...prev,
                industry: newValue,
              }));
              clearForm("industry", newValue);
            }}
            isLoading={industries2.isLoading}
            placeholder="صنعت"
          />
        </Grid2>
        <Grid2 xs={12} lg={2.4}>
          <CustomAutocomplete
            options={fields2.data}
            value={field}
            onChange={(e, newValue) => {
              setInputCategoryValues2((prev) => ({
                ...prev,
                field: newValue,
              }));
              clearForm("field", newValue);
            }}
            isLoading={fields2.isLoading}
            placeholder="زمینه"
          />
        </Grid2>

        <Grid2 xs={12} lg={2.4}>
          <CustomAutocomplete
            options={groups2.data}
            value={group}
            onChange={(e, newValue) => {
              setInputCategoryValues2((prev) => ({ ...prev, group: newValue }));
              clearForm("group", newValue);
            }}
            isLoading={groups2.isLoading}
            placeholder="گروه (اختیاری)"
          />
        </Grid2>
        <Grid2 xs={12} lg={2.4}>
          <CustomAutocomplete
            options={companies2.data}
            value={company}
            onChange={(e, newValue) => {
              setInputCategoryValues2((prev) => ({
                ...prev,
                company: newValue,
              }));
              clearForm("company", newValue);
            }}
            isLoading={companies2.isLoading}
            placeholder="شرکت (اختیاری)"
          />
        </Grid2>
        <Grid2 xs={12} lg={2.4}>
          <CustomAutocomplete
            options={commodities2.data}
            value={commodity}
            onChange={(e, newValue) => {
              setInputCategoryValues2((prev) => ({
                ...prev,
                commodity: newValue,
              }));
              clearForm("commodity", newValue);
            }}
            isLoading={commodities2.isLoading}
            placeholder="کالا (اختیاری)"
          />
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default CommodityForm2;
